// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h1[data-v-e6cd18f2]{word-wrap:break-word}h2[data-v-e6cd18f2]{margin:2rem 0 1rem 0;font-size:35px;font-size:1.9444444444rem;line-height:1.8857142857}p[data-v-e6cd18f2]{margin-bottom:1rem}.content[data-v-e6cd18f2]{margin-top:5em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
